
import { computed, defineComponent } from 'vue';

export default defineComponent({
    name: 'Indicator',
    props: {
        activeIndex: {
            type: Number,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    emits: ['onScrollTo'],
    setup(props, { emit }) {
        const conditionalClassObject = computed(() => {
            return {
                'indicator--active': indicatorIsActive(props.index),
                'indicator--small': indicatorIsTwoIndexApartFromActiveIndex(props.index),
                'indicator--smallest': indicatorIsMoreThanTwoIndexApartFromActiveIndex(props.index),
                hidden: indicatorIsMoreThanTreeIndexApartFromActiveIndex(props.index),
            };
        });

        const indicatorClicked = (event: any) => {
            emit('onScrollTo', { event, index: props.index });
        };

        const indicatorIsTwoIndexApartFromActiveIndex = (index: number): boolean => {
            return props.activeIndex - 2 === index || props.activeIndex + 2 === index;
        };

        const indicatorIsMoreThanTwoIndexApartFromActiveIndex = (index: number): boolean => {
            return props.activeIndex - 2 > index || props.activeIndex + 2 < index;
        };

        const indicatorIsMoreThanTreeIndexApartFromActiveIndex = (index: number): boolean => {
            return props.activeIndex - 3 > index || props.activeIndex + 3 < index;
        };

        const indicatorIsActive = (index: number): boolean => {
            return index === props.activeIndex;
        };

        return {
            conditionalClassObject,
            indicatorClicked,
        };
    },
});

